import { jsx as e } from "react/jsx-runtime";
import { LinearProgress as n } from "@mui/material";
const i = ({
  size: r = "small",
  ...s
}) => {
  const o = { ...s, size: r };
  return /* @__PURE__ */ e(n, { ...o });
};
export {
  i as LinearProgress
};
//# sourceMappingURL=index88.mjs.map
